import React from "react";
import "./AboutContant.css";
import Amain from "./IMG/Amain.svg";
import poly1 from "./IMG/Polygon 1.svg";
import poly2 from "./IMG/Polygon 2.svg";
import poly3 from "./IMG/Polygon 3.svg";

function AboutContant() {
  return (
    <>
      <section className="GHDf0187" aria-labelledby="about-quarec-heading">
        <div className="Vajf0971">
          <img className="khFS9861" src={Amain} alt="" />
        </div>
        <div className="DG9716">
          <h1 id="about-quarec-heading" className="JF08167">About Quarec Resources</h1>
          <p className="JGs07116">
            Quarec Resources Pvt. Ltd. provides recruitment and HR support for
            employers and jobseekers. We begin by understanding the role,
            required skills, location and hiring timeline, then help the parties
            communicate clearly through the selection process.
          </p>
          <p className="JGs07116">
            Each recruitment engagement depends on the employer’s requirements,
            the available candidate market and the scope agreed for the work.
            We aim to make role expectations and next steps clear for both
            employers and candidates.
          </p>
          <p className="JGs07116">
            A job offer, placement or immigration decision cannot be guaranteed.
            Employers make their hiring decisions, and government authorities
            determine visa and work-authorisation outcomes.
          </p>
        </div>
      </section>
      <div className="JD0178" aria-hidden="true">
        <img className="Vafs0917" src={poly1} alt="" />
        <img className="Vafs0917" src={poly2} alt="" />
        <img className="Vafs0917" src={poly3} alt="" />
      </div>
    </>
  );
}

export default AboutContant;
